import { useSelector } from "react-redux";
import { selectAuthData } from "../../redux/features/auth/authSlice";
import { useMemo } from "react";

export const useAuth = () => {
  const auth = useSelector(selectAuthData);
  return useMemo(() => ({ auth }), [auth]);
};
